import styled from 'styled-components';

import { S3_BUCKET_URL } from '@/constants';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  padding-bottom: 18px;

  ion-content {
    --background: url(${S3_BUCKET_URL}/layout-own-ai-dominate-v2/protect/image.png)
      no-repeat center center / cover;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(160, 0, 0, 0.8) 0%,
        rgba(0, 0, 0, 0.5) 65.98%,
        #000 82%,
        #000 100%
      );
      backdrop-filter: blur(4px);
      z-index: 1;
      pointer-events: none;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      pointer-events: none;
      background: rgba(0, 0, 0, 0.5);
    }

    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      position: relative;
      z-index: 2;
      padding-top: 200px;
    }

    .title {
      margin-bottom: 8px;
    }
  }
`;

export const ContentContainerStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
`;
